import { WSPanel } from "@wingspanhq/fe-component-library";
import {
  DocumentTemplate,
  DocumentTemplatesApiCreateDocumentTemplateRequest,
  DocumentTemplateSignerRole
} from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";

import { CreateSignaturePartialForm } from "../../../../modules/Signature/createRequirementDefinition/CreateSignaturePartialForm";
import { RequirementDefinitionSignatureFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_ESIGNATURE_FORM: RequirementDefinitionTemplateForm<
  DocumentTemplate,
  RequirementDefinitionSignatureFormValues,
  DocumentTemplatesApiCreateDocumentTemplateRequest
> = {
  getDefaultSettingsValues: template => ({
    fileId: "",
    requiredSignatures: "collaborator",
    signedDocumentTemplateId: ""
  }),
  getEditSettingsValues(template, requirementDefinition, settings) {
    const requiredSignatures = settings.signerRoles?.includes(
      DocumentTemplateSignerRole.PAYER
    )
      ? "mutual"
      : "collaborator";

    return {
      fileId: settings.fileId ?? "",
      requiredSignatures,
      signedDocumentTemplateId: settings.id ?? ""
    };
  },
  // Unused for Signature: the template is minted during the file upload in
  // `CreateSignaturePartialForm`, so the shared create flow takes the
  // `mapFormDataToRequirementCreateRequest` branch below instead of creating a
  // data source of its own. Both are declared to satisfy the template contract.
  mapDataSourceResponseToRequirementCreateRequest(response) {
    return {
      dataSourceId: response.id ?? ""
    };
  },
  mapFormDataToDataSourceCreateRequest(formValues) {
    return {
      documentTemplateCreate: {
        fileId: formValues.fileId,
        signerRoles:
          formValues.requiredSignatures === "collaborator"
            ? [DocumentTemplateSignerRole.PAYEE]
            : [
                DocumentTemplateSignerRole.PAYEE,
                DocumentTemplateSignerRole.PAYER
              ],
        title: formValues.name
      }
    };
  },
  mapFormDataToRequirementCreateRequest(formValues) {
    return {
      dataSourceId: formValues.signedDocumentTemplateId
    };
  },
  partialForm: (
    <WSPanel>
      <CreateSignaturePartialForm />
    </WSPanel>
  ),
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({
    fileId: Yup.string().required("Required"),
    requiredSignatures: Yup.string()
      .oneOf(["collaborator", "mutual"])
      .required("Required") as Yup.AnySchema,
    signedDocumentTemplateId: Yup.string().required("Required")
  })
};
